<template>
  <div>
    <base-modal name="update">
      <template #body>
        <div class="mt-50">
          <h6 class="font-semibold text-24 text-title">{{ $t(`${name}`) }}</h6>
          <div class="my-50" v-for="field in fields" :key="field">
            <div v-if="field === 'logo' || field === 'avatar'" class="w-78 h-78">
              <edit-avatar
                :type="data[field] ? 'edit' : 'add'"
                :isLabelShow="!data[field]"
                :avatar="data[field]"
                @click.native="$store.dispatch('modal/open', 'AdminUploadAvatar')"
              >
                <template #text>
                  <span class="text-sm">
                    {{ $t('profile') }}
                  </span>
                </template>
              </edit-avatar>
            </div>
            <div
              v-if="
                field !== 'logo' &&
                field !== 'avatar' &&
                field !== 'invitation_code' &&
                field !== 'owner_name' &&
                field !== 'owner_mobile' &&
                field !== 'company_name'
              "
            >
              <p class="font-bold text-18">{{ field }}</p>
              <date-picker
                v-if="field.includes('date')"
                format="YYYY-MM-DD HH:mm:ss"
                locale="en"
                v-model="data[field]"
                type="datetime"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                :timezone="true"
              />
              <phone-number-input
              v-else-if="field === 'mobile'"
                @countryCode="getCountryCode"
                @isPhoneValid="phoneValidation"
                :isLogin="true"
                :inputValue="data[field]"
                v-model="data[field]"
                width="full"
                :userCountryCode="data.country_code"
                @changedCode="changedCodeHandler"
              />
              <base-input
                v-else
                width="full"
                :id="`admin_modal_${field}`"
                :fieldType="field"
                @change="saveInput"
                :inputValue="data[field]"
              >
                <template #text>
                  <span class="text-18 font-normal">
                    {{ $t(`${field}`) }}
                  </span>
                </template>
              </base-input>
            </div>
          </div>
        </div>
      </template>
      <template #action>
        <div class="grid grid-cols-2 gap-20">
          <base-button
            class="w-full"
            buttonType="cancel"
            width="169"
            @click.native="closeModal('update')"
          >
            <template #text>
              <span class="text-title">
                {{ $t('close') }}
              </span>
            </template>
          </base-button>
          <base-button class="w-full" width="169" @click.native="save('update')"
           :disabled="isButtonDisabled">
            <template #text>
              {{ $t('save') }}
            </template>
          </base-button>
        </div>
      </template>
    </base-modal>
    <admin-upload-avatar
      :avatar="data['logo']? data['logo'] : data['avatar']"
      :hasProfile="data['logo'] || data['avatar'] ? true : false"
      :profileOf="logoOrAvatar"
      @imageUploaded="imageUploadedHandler"
    ></admin-upload-avatar>
  </div>
</template>

<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import EditAvatar from '@/components/EditAvatar.vue';
import AdminUploadAvatar from '@/components/admin/dashboard/AdminUploadAvatar.vue';
import { mapGetters } from 'vuex';
import PhoneNumberInput from '@/components/PhoneNumberInput.vue';
import BaseModal from './BaseModal.vue';
import BaseButton from '../base/BaseButton.vue';
import BaseInput from '../base/BaseInput.vue';

export default {
  name: 'UpdateModal',
  data() {
    return {
      data: [],
      isButtonDisabled: false,
    };
  },
  components: {
    AdminUploadAvatar,
    datePicker: VuePersianDatetimePicker,
    BaseInput,
    BaseModal,
    BaseButton,
    EditAvatar,
    PhoneNumberInput,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.fields.forEach((field) => {
      this.data[field] = '';
    });
    if (this.fields.includes('mobile')) {
      this.isButtonDisabled = true;
    }
  },
  watch: {
    AdminPanelItemData() {
      this.data = this.AdminPanelItemData;
    },
  },
  computed: {
    ...mapGetters({
        AdminPanelItemData: 'getAdminPanelItemData',
      }),
    logoOrAvatar() {
      if (this.fields.includes('avatar')) {
        return 'avatar';
      // eslint-disable-next-line no-else-return
      } else {
        return 'logo';
      }
    },
  },
  methods: {
    imageUploadedHandler(imageUrl) {
      // eslint-disable-next-line dot-notation
      this.data[this.logoOrAvatar] = imageUrl;
    },
    closeModal(name) {
      this.$store.dispatch('modal/close', name);
    },
    save(name) {
      this.$emit('save', this.data);
      this.data = [];
      this.$store.dispatch('modal/close', name);
    },
    saveInput(event, fieldType) {
      this.data[fieldType] = event;
    },
    getCountryCode(code) {
      this.$store.state.authentication.countryCode = code;
    },
    phoneValidation(val) {
      this.isButtonDisabled = val;
    },
    changedCodeHandler(code) {
      this.data.country_code = code;
    },
  },
};
</script>
